<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
  >
    <rect
      x="0.5"
      y="1"
      width="23"
      height="23"
      rx="11.5"
      fill="#4D4D4D"
      stroke="#999999"
    />
    <path
      d="M11.3208 17.5C10.9961 17.5 10.6832 17.3629 10.4514 17.114L7.35658 13.7914C6.88114 13.281 6.88114 12.4473 7.35658 11.9374C7.83202 11.427 8.60858 11.427 9.08348 11.9374L11.2859 14.3019L15.8763 8.92595C16.3282 8.39073 17.1053 8.3533 17.6032 8.85109C18.1018 9.33623 18.1366 10.1705 17.673 10.7051L12.225 17.0771C12.0049 17.3386 11.6803 17.5 11.3438 17.5H11.3207L11.3208 17.5Z"
      fill="white"
    />
  </svg>
</template>
